import React from "react";
import Menu from "@mui/material/Menu";
import Log from "./Log";
import Clone from "./Clone";
import Delete from "./Delete";
import Start from "./Startlab";
import Stop from "./Stoplab";
import SupportTeam from "./SupportTeam";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UnCordoned from "./UnCordoned";

export default function SimpleMenu(props) {
  const { InstanceID, name, count, status, spent, budget,lab_id, billingtype, start_date, start_time, end_date, end_time,  machine_count, number_of_trainee,application } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Log InstanceID={InstanceID} />
        {status === "Failed" ||
        status === "Cordoned" ||
        status === "Creating" ||
        status === "Running" ||
        status === "Retrying" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Start
            InstanceID={InstanceID}
            status={status}
            spent={spent}
            budget={budget}
            billingtype={billingtype}
          />
        )}
        {status === "Failed" ||
        status === "Cordoned" ||
        status === "Creating" ||
        status === "Stopped" ||
        status === "Retrying" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Stop InstanceID={InstanceID} status={status} />
        )}
        <SupportTeam status={status} />
        {status === "Creating" ||
        status === "Retrying" ||
        status === "Stopping" ? (
          ""
        ) : (
          <Delete InstanceID={InstanceID} name={name} status={status} />
        )}
        {status === "Cordoned" ? (
          <UnCordoned
            InstanceID={InstanceID}
            name={name}
            status={status}
            spent={spent}
            budget={budget}            
            start_date={start_date}
            start_time={start_time}
            end_date={end_date}
            end_time={end_time}
            billingtype={billingtype}
            number_of_trainee={number_of_trainee}
            application={application}
            lab_id={lab_id}
          />
        ) : (
          ""
        )}
      </Menu>
    </div>
  );
}
